import { PaymentTerm } from "src/app/services/response-models/contacts.response.model";

export class SetPaymentTerms {
    static readonly type = "[Contacts] Set payment terms";

    constructor(public payload: PaymentTerm[]) {}
}
